export default class Download {
  static downloadFileFromText(name: string, content: string) {
    // Support for Edge browser
    if ('msSaveOrOpenBlob' in window.navigator) {
      // msSaveOrOpenBlob is deprecated. It has also been removed
      // from the typings which is why we're using any here.
      // This piece of code should eventually be removed.
      const navigator: any = window.navigator
      navigator.msSaveOrOpenBlob(new Blob([content]), name)
    } else {
      const element = document.createElement('a')
      element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(content)}`)
      element.setAttribute('download', name)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    }
  }
}
